import { createReducer, on } from "@ngrx/store"
import { TrainData } from "../../models/trainDataModel"
import { fetchMessageData, fetchTrainData, updateMessageData, updateTrainData, trainDataError, messageDataError } from "./home.action"
import { MessageData } from "../../models/messageDataModel"

export interface HomeState {
    trainData: TrainData,
    messageData: MessageData[]
    fetchingTrainData: boolean
    fetchingMessageData: boolean
}

export const initialState: HomeState = {
    trainData: {
        data: undefined,
        delayMeanValue: undefined,
        httpCode: undefined,
        status: undefined,
        trainOnTimePercentage: undefined,
        utc: undefined,
        swedishTime: undefined,
        delayLimit: undefined
    },
    messageData: [],
    fetchingTrainData: true,
    fetchingMessageData: true
}

export const homeReducer = createReducer(
    initialState,
    on(fetchTrainData, state => ({
        ...state,
        fetchingTrainData: true
    })),
    on(updateTrainData, (state, { trainData }) => ({
        ...state,
        trainData: trainData,
        fetchingTrainData: false
    })),
    on(trainDataError, state => ({
        ...state,
        fetchingTrainData: false
    })),
    on(fetchMessageData, state => ({
        ...state,
        fetchingMessageData: true
    })),
    on(updateMessageData, (state, { messageData }) => ({
        ...state,
        messageData: messageData,
        fetchingMessageData: false
    })),
    on(messageDataError, state => ({
        ...state,
        fetchingMessageData: false
    }))
)